import { cn } from '@/shared/utils';

interface AudioWaveIndicatorProps {
  className?: string;
  barCount?: number;
  size?: 'sm' | 'md' | 'lg';
}

const sizeConfig = {
  sm: {
    height: 'h-4',
    width: 'w-1',
    gap: 'gap-0.5',
  },
  md: {
    height: 'h-6',
    width: 'w-1.5',
    gap: 'gap-1',
  },
  lg: {
    height: 'h-8',
    width: 'w-2',
    gap: 'gap-1.5',
  },
};

export const AudioWaveIndicator = ({
  className,
  barCount = 4,
  size = 'md',
}: AudioWaveIndicatorProps) => {
  const config = sizeConfig[size];

  return (
    <div
      className={cn('flex items-center', config.gap, className)}
      data-testid="audio-wave-indicator"
      role="img"
      aria-label="Audio playing indicator"
    >
      {Array.from({ length: barCount }, (_, i) => (
        <div
          key={i}
          data-testid={`wave-bar-${i}`}
          className={cn(
            'rounded-full bg-gradient-to-t from-emerald-400 to-emerald-200',
            config.width,
            config.height,
          )}
          style={{
            animation: `wave 1.2s ease-in-out infinite`,
            animationDelay: `${i * 0.15}s`,
          }}
        />
      ))}
      <style>{`
        @keyframes wave {
          0%, 100% {
            transform: scaleY(0.3);
            opacity: 0.6;
          }
          50% {
            transform: scaleY(1);
            opacity: 1;
          }
        }
      `}</style>
    </div>
  );
};
